module.exports = __webpack_public_path__ + "img/boost-header.5289c999.png";